import React from 'react'
import { Helmet } from 'react-helmet'
import Header from '../../../Components/Header'
import CreateCustomerForm from './CreateCustomerForm'
// code written by akash -> Akash.ak@stackerbee.com
function CreateCustomer() {
    return (
        <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
            <Helmet>
                <title>Customer - Create</title>
            </Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
                <CreateCustomerForm />
            </div>
        </div>


    )
}

export default CreateCustomer
